import styled from 'styled-components';

export const ControlOptions = styled.div`   
    margin-top: 10px;
    width: 65%;
    display: flex;
    justify-content: space-between;
    div {
        width: 46%;
        button {
            width: 100%;
        }
    }
`;